import PropTypes from 'prop-types';
import React, {useEffect} from 'react';
import Leaflet from 'leaflet';
import isArray from 'lodash/isArray';
import { useMap } from './MapContext';

const LinePath = ({pathArray, styles = {
    weight: 4,
}}) => {
    const { map } = useMap();
    useEffect(() => {
        if (map && isArray(pathArray) && pathArray.length > 1) {
            const line = new Leaflet.Polyline(pathArray, styles).addTo(map);

            return () => {
                line.removeFrom(map);
            };
        }
        return undefined;
    }, [pathArray, map, styles]);
    return null;
};

LinePath.propTypes = {
    pathArray: PropTypes.arrayOf(PropTypes.object),
    map: PropTypes.object,
    styles: PropTypes.object,
};

export default React.memo(LinePath);



// WEBPACK FOOTER //
// ./src/components/openMap/LinePath.js